import { useEffect, useState } from "react";
import { PlaylistItemData } from "../data/PlaylistItemData";
import { CyPlaylistItem } from "./CyPlaylistItem";
import { LookupSongFunction } from "../../common/LookupSongFunction";
import {
  BadgeProvider,
  SongBadges,
} from "../../common/components/song/SongBadges";
import { LyricsPreview } from "../../common/components/song/LyricsPreview";
import { undefinedToNull } from "../../helper/nullToUndefined";
import { SongUb } from "../../gql/graphql";

interface Props {
  playlistEntry: PlaylistItemData;
  lookupSong: LookupSongFunction;
}

export function PlaylistItemSong({ playlistEntry, lookupSong }: Props) {
  const [song, setSong] = useState<SongUb | undefined>(
    lookupSong(playlistEntry.songEntryId),
  );

  useEffect(() => {
    setSong(lookupSong(playlistEntry.songEntryId));
  }, [playlistEntry, lookupSong]);

  if (!song) {
    return <>"Error: Component can only render found items."</>;
  }

  const songBadgesEntry: BadgeProvider = {
    ...song,
    tonality: undefinedToNull(song.tonality),
    songnumbers: song.songnumbers.map((s) => ({
      mnemonicNumber: s.mnemonicNumber,
    })),
    language: null,
  };

  return (
    <>
      <div>
        <span data-cy={CyPlaylistItem.EntryTitle}>{song.title}</span>
      </div>
      <LyricsPreview songId={song.id} />

      <SongBadges badgeProvider={songBadgesEntry} />
    </>
  );
}
